import { Directive, HostBinding, Input, OnInit, ElementRef, HostListener, Renderer2, AfterViewInit } from '@angular/core';
declare var EXIF: any;

@Directive({
  // selector: '[appImageOrientation]'
  selector: 'img.needToSetOrientation'
})
export class ImageOrientationDirective implements OnInit {

  @HostListener('load')
  onLoad() {
    this.getExif();
  }

  constructor(private el: ElementRef, private renderer: Renderer2, hostElement: ElementRef) {}

  ngOnInit() {
  }

  private getExif() {
    EXIF.getData(<HTMLImageElement>this.el.nativeElement, () => {
      let orientation = EXIF.getTag(this.el.nativeElement, 'Orientation');
// console.log(`=== this.el.nativeElement = `,this.el.nativeElement, orientation);

      switch (orientation) {
        // case 2: this.renderer.addClass(this.el.nativeElement, 'rotateClass2'); break;
        case 3: this.renderer.addClass(this.el.nativeElement, 'rotateClass180'); break;
        // case 4: this.renderer.addClass(this.el.nativeElement, 'rotateClass4'); break;
        // case 5: this.renderer.addClass(this.el.nativeElement, 'rotateClass5'); break;
        case 6: this.renderer.addClass(this.el.nativeElement, 'rotateimg90');
          this.renderer.setStyle(this.el.nativeElement, 'height', '525px')
            ; break;
        // case 7: this.renderer.addClass(this.el.nativeElement, 'rotateClass7'); break;
        case 8: this.renderer.addClass(this.el.nativeElement, 'rotateimg-90'); break;

        default: break;
      }
    });


  }

}
